// import React, { useState, useCallback, useEffect } from "react";
// import { 
//   FaChartBar, 
//   FaChartPie, 
//   FaCheckCircle, 
//   FaClock, 
//   FaExclamationCircle,
//   FaClipboardCheck,
//   FaCalendarCheck,
//   FaRegCalendarAlt,
//   FaChartLine,
//   FaExclamationTriangle,
//   FaUsers,
//   FaStar,
//   FaUtensils,
//   FaShieldAlt
// } from "react-icons/fa";

// const ComplianceStatus = ({ isMobile }) => {
//     const [complianceData, setComplianceData] = useState({
//         privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15" },
//         termsConditions: { status: "pending", lastUpdated: "2024-02-28" },
//         vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20" },
//         gdpr: { status: "compliant", lastUpdated: "2024-03-10" },
//         dataRetention: { status: "compliant", lastUpdated: "2024-03-05" }
//     });

//     const [vendorId, setVendorId] = useState(null);

//     const getStatusIcon = useCallback((status) => {
//         switch(status) {
//             case 'compliant': return <FaCheckCircle aria-hidden="true" style={{ color: '#4CAF50', marginRight: '5px' }} />;
//             case 'pending': return <FaClock aria-hidden="true" style={{ color: '#FFC107', marginRight: '5px' }} />;
//             case 'non-compliant': return <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '5px' }} />;
//             default: return null;
//         }
//     }, []);

//     const getStatusColor = useCallback((status) => {
//         switch(status) {
//             case 'compliant': return '#4CAF50';
//             case 'pending': return '#FFC107';
//             case 'non-compliant': return '#f44336';
//             default: return '#757575';
//         }
//     }, []);

//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) {
//             setVendorId(storedVendorId);
//         }
//     }, []);

//     return (
//         <div style={{
//             backgroundColor: "#fff",
//             borderRadius: "10px",
//             padding: isMobile ? "15px" : "25px",
//             border: "1px solid #e0e0e0",
//             minHeight: "400px",
//             overflow: "auto"
//         }}>
//             <h3 style={{ 
//                 color: '#A055B0', 
//                 marginBottom: '25px',
//                 fontSize: isMobile ? '20px' : '24px',
//                 textAlign: 'center',
//                 paddingBottom: '15px',
//                 borderBottom: '3px solid #A055B0'
//             }}>
//                 <FaChartBar aria-hidden="true" style={{ marginRight: '15px' }} />
//                 Food & Beverages Compliance Dashboard
//             </h3>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     flexDirection: isMobile ? 'column' : 'row',
//                     gap: isMobile ? '15px' : '0'
//                 }}>
//                     <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
//                         <h4 style={{ 
//                             fontSize: isMobile ? '18px' : '22px',
//                             color: '#2e7d32',
//                             marginBottom: '10px'
//                         }}>
//                             <FaChartPie aria-hidden="true" style={{ marginRight: '10px' }} />
//                             Overall Food Safety Compliance Score
//                         </h4>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#555' }}>
//                             Based on comprehensive assessment of food safety, hygiene, quality standards, and operational excellence
//                         </p>
//                     </div>
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '20px',
//                         border: "1px solid #e0e0e0",
//                         borderRadius: '10px',
//                         minWidth: isMobile ? '100%' : '200px',
//                     }}>
//                         <div style={{
//                             fontSize: isMobile ? '36px' : '48px',
//                             fontWeight: 'bold',
//                             color: '#4CAF50',
//                             marginBottom: '5px'
//                         }}>
//                             94%
//                         </div>
//                         <div style={{ 
//                             fontSize: isMobile ? '14px' : '16px',
//                             color: '#666'
//                         }}>
//                             Excellent Compliance
//                         </div>
//                         <div style={{
//                             fontSize: '12px',
//                             color: '#4CAF50',
//                             marginTop: '5px',
//                             fontWeight: 'bold'
//                         }}>
//                             ▲ 2% from last month
//                         </div>
//                     </div>
//                 </div>
                
//                 <div style={{ marginTop: '25px' }}>
//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaUtensils aria-hidden="true" style={{ marginRight: '5px', color: '#4CAF50' }} />
//                                 Food Safety Standards
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#4CAF50' }}>96%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '96%',
//                                 height: '100%',
//                                 backgroundColor: '#4CAF50',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaShieldAlt aria-hidden="true" style={{ marginRight: '5px', color: '#2196F3' }} />
//                                 Hygiene & Sanitation
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#2196F3' }}>92%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '92%',
//                                 height: '100%',
//                                 backgroundColor: '#2196F3',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaStar aria-hidden="true" style={{ marginRight: '5px', color: '#FF9800' }} />
//                                 Quality Control
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#FF9800' }}>91%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '91%',
//                                 height: '100%',
//                                 backgroundColor: '#FF9800',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaClipboardCheck aria-hidden="true" style={{ marginRight: '5px', color: '#9C27B0' }} />
//                                 Operational Excellence
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#9C27B0' }}>88%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '88%',
//                                 height: '100%',
//                                 backgroundColor: '#9C27B0',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div style={{ 
//                 marginBottom: '10px',
//                 padding: '20px',
//                 borderRadius: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '16px' : '18px',
//                     color: '#333',
//                     marginBottom: '15px',
//                     textAlign: 'center'
//                 }}>
//                     🍽️ Food & Beverages Compliance Categories
//                 </h4>
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
//                     gap: '15px',
//                     marginBottom: '20px'
//                 }}>
//                     {[
//                         { 
//                             id: 'food-safety', 
//                             name: 'Food Safety', 
//                             description: 'Temperature control, storage, handling',
//                             icon: <FaShieldAlt aria-hidden="true" />, 
//                             color: '#4CAF50',
//                             score: '96%'
//                         },
//                         { 
//                             id: 'hygiene', 
//                             name: 'Hygiene Standards', 
//                             description: 'Staff hygiene, sanitation, cleaning',
//                             icon: <FaUsers aria-hidden="true" />, 
//                             color: '#2196F3',
//                             score: '92%'
//                         },
//                         { 
//                             id: 'quality', 
//                             name: 'Quality Control', 
//                             description: 'Ingredients, preparation, consistency',
//                             icon: <FaStar aria-hidden="true" />, 
//                             color: '#FF9800',
//                             score: '91%'
//                         },
//                         { 
//                             id: 'operations', 
//                             name: 'Operations', 
//                             description: 'Service, documentation, training',
//                             icon: <FaClipboardCheck aria-hidden="true" />, 
//                             color: '#9C27B0',
//                             score: '88%'
//                         }
//                     ].map(category => (
//                         <div 
//                             key={category.id}
//                             style={{
//                                 padding: '20px',
//                                 borderRadius: '8px',
//                                 textAlign: 'center',
//                                 border: `1px solid ${category.color}`,
//                                 transition: 'all 0.3s ease',
//                                 cursor: 'pointer'
//                             }}
//                             onMouseEnter={(e) => {
//                                 e.currentTarget.style.transform = 'translateY(-5px)';
//                             }}
//                             onMouseLeave={(e) => {
//                                 e.currentTarget.style.transform = 'translateY(0)';
//                             }}
//                             onClick={() => alert(`View ${category.name} details`)}
//                         >
//                             <div style={{ 
//                                 fontSize: '32px', 
//                                 color: category.color,
//                                 marginBottom: '15px'
//                             }}>
//                                 {category.icon}
//                             </div>
//                             <div style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 fontWeight: 'bold',
//                                 color: '#333',
//                                 marginBottom: '8px'
//                             }}>
//                                 {category.name}
//                             </div>
//                             <div style={{ 
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 color: '#666',
//                                 marginBottom: '15px',
//                                 minHeight: '40px'
//                             }}>
//                                 {category.description}
//                             </div>
//                             <div style={{
//                                 fontSize: '24px',
//                                 fontWeight: 'bold',
//                                 color: category.color,
//                                 padding: '8px',
//                                 borderRadius: '6px'
//                             }}>
//                                 {category.score}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             <div style={{ 
//                 display: 'grid', 
//                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', 
//                 gap: '20px', 
//                 marginBottom: '10px' 
//             }}>
//                 {[
//                     { 
//                         title: "Temperature Control", 
//                         status: "compliant", 
//                         score: "98%",
//                         icon: <FaCheckCircle aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "Today",
//                         details: "Refrigeration, cooking, holding temperatures",
//                         trend: "▲ 1%"
//                     },
//                     { 
//                         title: "Staff Hygiene", 
//                         status: "compliant", 
//                         score: "95%",
//                         icon: <FaClipboardCheck aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "2 days ago",
//                         details: "Hand washing, uniform, health checks",
//                         trend: "▲ 2%"
//                     },
//                     { 
//                         title: "Ingredient Quality", 
//                         status: "compliant", 
//                         score: "96%",
//                         icon: <FaStar aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "Yesterday",
//                         details: "Freshness, sourcing, storage",
//                         trend: "▲ 3%"
//                     },
//                     { 
//                         title: "Food Storage", 
//                         status: "pending", 
//                         score: "88%",
//                         icon: <FaClock aria-hidden="true" />,
//                         color: "#FFC107",
//                         lastCheck: "1 week ago",
//                         details: "FIFO, labeling, segregation",
//                         trend: "▼ 2%"
//                     },
//                     { 
//                         title: "Preparation Standards", 
//                         status: "compliant", 
//                         score: "94%",
//                         icon: <FaCheckCircle aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "3 days ago",
//                         details: "Cooking methods, cross-contamination",
//                         trend: "▲ 1%"
//                     },
//                     { 
//                         title: "Cleaning Procedures", 
//                         status: "attention", 
//                         score: "82%",
//                         icon: <FaExclamationCircle aria-hidden="true" />,
//                         color: "#f44336",
//                         lastCheck: "2 weeks ago",
//                         details: "Sanitization, equipment cleaning",
//                         trend: "▼ 5%"
//                     }
//                 ].map((item, index) => (
//                     <div 
//                         key={index} 
//                         style={{
//                             backgroundColor: "#fff",
//                             borderRadius: "8px",
//                             padding: "15px",
//                             minHeight: "100px",
//                             border: "1px solid #e0e0e0",
//                             borderLeft: `5px solid ${item.color}`,
//                             transition: 'all 0.3s ease',
//                             cursor: 'pointer',
//                             position: 'relative'
//                         }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'translateY(-5px)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'translateY(0)';
//                         }}
//                         onClick={() => alert(`View details for ${item.title}`)}
//                     >
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between', 
//                             alignItems: 'flex-start',
//                             marginBottom: '15px'
//                         }}>
//                             <div style={{ flex: 1 }}>
//                                 <h5 style={{ 
//                                     margin: '0 0 5px 0', 
//                                     color: '#333',
//                                     fontSize: isMobile ? '14px' : '16px',
//                                     fontWeight: 'bold'
//                                 }}>
//                                     {item.title}
//                                 </h5>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     alignItems: 'center',
//                                     marginBottom: '5px'
//                                 }}>
//                                     <span style={{ 
//                                         color: item.color,
//                                         fontWeight: 'bold',
//                                         fontSize: isMobile ? '18px' : '22px',
//                                         marginRight: '10px'
//                                     }}>
//                                         {item.score}
//                                     </span>
//                                     <span style={{ 
//                                         color: item.color,
//                                         padding: '3px 8px',
//                                         borderRadius: '12px',
//                                         fontSize: '11px',
//                                         fontWeight: 'bold',
//                                         textTransform: 'uppercase'
//                                     }}>
//                                         {item.status}
//                                     </span>
//                                 </div>
//                                 <div style={{ 
//                                     fontSize: '12px',
//                                     color: '#666',
//                                     marginTop: '8px',
//                                     lineHeight: '1.4'
//                                 }}>
//                                     {item.details}
//                                 </div>
//                             </div>
//                             <div style={{ 
//                                 fontSize: '24px', 
//                                 color: item.color,
//                                 marginLeft: '10px'
//                             }}>
//                                 {item.icon}
//                             </div>
//                         </div>
                        
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             fontSize: '12px',
//                             color: '#666',
//                             marginTop: '15px',
//                             paddingTop: '10px',
//                             borderTop: '1px solid #f0f0f0'
//                         }}>
//                             <div style={{ display: 'flex', alignItems: 'center' }}>
//                                 <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '5px', fontSize: '10px' }} />
//                                 Checked: {item.lastCheck}
//                             </div>
//                             <div style={{
//                                 color: item.trend.startsWith('▲') ? '#4CAF50' : 
//                                        item.trend.startsWith('▼') ? '#f44336' : '#666',
//                                 fontWeight: 'bold'
//                             }}>
//                                 {item.trend}
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#1565c0',
//                     marginBottom: '20px',
//                     display: 'flex',
//                     alignItems: 'center'
//                 }}>
//                     <FaCalendarCheck aria-hidden="true" style={{ marginRight: '10px' }} />
//                     Upcoming Food Safety Audits & Inspections
//                 </h4>
                
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                     gap: '15px'
//                 }}>
//                     {[
//                         { 
//                             title: "FSSAI Annual Inspection", 
//                             date: "2024-04-15", 
//                             status: "scheduled",
//                             type: "Regulatory",
//                             priority: "high",
//                             inspector: "Food Safety Officer",
//                             location: "Main Kitchen"
//                         },
//                         { 
//                             title: "Kitchen Hygiene Audit", 
//                             date: "2024-04-22", 
//                             status: "scheduled",
//                             type: "Internal",
//                             priority: "medium",
//                             inspector: "Quality Manager",
//                             location: "All Areas"
//                         },
//                         { 
//                             title: "Staff Training Assessment", 
//                             date: "2024-05-01", 
//                             status: "pending",
//                             type: "Training",
//                             priority: "medium",
//                             inspector: "Training Department",
//                             location: "Training Room"
//                         },
//                         { 
//                             title: "Supplier Quality Review", 
//                             date: "2024-05-10", 
//                             status: "planned",
//                             type: "Vendor",
//                             priority: "high",
//                             inspector: "Procurement Team",
//                             location: "Storage & Kitchen"
//                         }
//                     ].map((audit, index) => (
//                         <div 
//                             key={index}
//                             style={{
//                                 padding: '20px',
//                                 borderRadius: '8px',
//                                 border: '1px solid #e0e0e0'
//                             }}
//                         >
//                             <div style={{ 
//                                 display: 'flex', 
//                                 justifyContent: 'space-between',
//                                 alignItems: 'flex-start',
//                                 marginBottom: '10px',
//                                 flexDirection: isMobile ? 'column' : 'row',
//                                 gap: isMobile ? '8px' : '0'
//                             }}>
//                                 <div style={{ flex: 1 }}>
//                                     <h6 style={{ 
//                                         margin: 0,
//                                         fontSize: isMobile ? '14px' : '16px',
//                                         fontWeight: 'bold',
//                                         color: '#333',
//                                         lineHeight: '1.3'
//                                     }}>
//                                         {audit.title}
//                                     </h6>
//                                     <div style={{ 
//                                         fontSize: isMobile ? '11px' : '12px',
//                                         color: '#666',
//                                         marginTop: isMobile ? '3px' : '5px'
//                                     }}>
//                                         <div>Inspector: {audit.inspector}</div>
//                                         <div>Location: {audit.location}</div>
//                                     </div>
//                                 </div>
//                                 <span style={{ 
//                                     color: audit.status === 'scheduled' ? '#2e7d32' : 
//                                            audit.status === 'pending' ? '#FF9800' : '#2196F3',
//                                     padding: '4px 10px',
//                                     borderRadius: '12px',
//                                     fontSize: isMobile ? '10px' : '12px',
//                                     fontWeight: 'bold',
//                                     whiteSpace: 'nowrap',
//                                     alignSelf: isMobile ? 'flex-start' : 'center'
//                                 }}>
//                                     {audit.status.toUpperCase()}
//                                 </span>
//                             </div>
//                             <div style={{ 
//                                 display: 'flex', 
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                                 fontSize: isMobile ? '11px' : '13px',
//                                 color: '#666',
//                                 marginTop: '15px',
//                                 flexDirection: isMobile ? 'column' : 'row',
//                                 gap: isMobile ? '8px' : '0',
//                                 alignItems: isMobile ? 'flex-start' : 'center'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                                     <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '8px', fontSize: isMobile ? '12px' : '14px' }} />
//                                     <strong>Date:</strong> {audit.date}
//                                 </div>
//                                 <div style={{ alignSelf: isMobile ? 'flex-start' : 'center' }}>
//                                     <span style={{ 
//                                         color: audit.priority === 'high' ? '#f44336' : 
//                                                audit.priority === 'medium' ? '#FF9800' : '#4CAF50',
//                                         padding: '4px 8px',
//                                         borderRadius: '10px',
//                                         fontSize: isMobile ? '10px' : '11px',
//                                         fontWeight: 'bold',
//                                         display: 'inline-block',
//                                         textAlign: 'center'
//                                     }}>
//                                         {audit.type} | {audit.priority.toUpperCase()} PRIORITY
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#e65100',
//                     marginBottom: '20px',
//                     display: 'flex',
//                     alignItems: 'center'
//                 }}>
//                     <FaClipboardCheck aria-hidden="true" style={{ marginRight: '10px' }} />
//                     Required Actions for Food Safety Compliance
//                 </h4>
                
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                     gap: '15px',
//                     marginBottom: '20px'
//                 }}>
//                     <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             alignItems: 'center',
//                             marginBottom: '15px'
//                         }}>
//                             <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '10px', fontSize: '20px' }} />
//                             <strong style={{ color: '#f44336', fontSize: isMobile ? '14px' : '16px' }}>
//                                 Immediate Attention Required (Within 48 hours)
//                             </strong>
//                         </div>
//                         <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Deep Cleaning Schedule:</strong> Complete overdue deep cleaning of walk-in refrigerator
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Temperature Logs:</strong> Submit missing temperature logs for March 15-20
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Staff Training:</strong> 2 kitchen staff need food handler certification renewal
//                             </li>
//                             <li style={{ paddingLeft: '10px' }}>
//                                 <strong>Equipment Calibration:</strong> Calibrate meat thermometer by tomorrow
//                             </li>
//                         </ul>
//                     </div>
                    
//                     <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             alignItems: 'center',
//                             marginBottom: '15px'
//                         }}>
//                             <FaClock aria-hidden="true" style={{ color: '#FF9800', marginRight: '10px', fontSize: '20px' }} />
//                             <strong style={{ color: '#FF9800', fontSize: isMobile ? '14px' : '16px' }}>
//                                 Upcoming Compliance Deadlines
//                             </strong>
//                         </div>
//                         <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Q1 Safety Report:</strong> Due April 30, 2024
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Pest Control Service:</strong> Scheduled for May 5, 2024
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Fire Safety Inspection:</strong> Due May 15, 2024
//                             </li>
//                             <li style={{ paddingLeft: '10px' }}>
//                                 <strong>Annual Staff Health Check:</strong> Due June 1, 2024
//                             </li>
//                         </ul>
//                     </div>
//                 </div>
                
//                 <div style={{ textAlign: 'center' }}>
//                     <button 
//                         onClick={() => alert("Generate Food Safety Report clicked")}
//                         style={{
//                             backgroundColor: '#4CAF50',
//                             color: 'white',
//                             border: 'none',
//                             padding: isMobile ? '10px 20px' : '15px 40px',
//                             borderRadius: '50px',
//                             cursor: 'pointer',
//                             fontSize: isMobile ? '14px' : '16px',
//                             fontWeight: 'bold',
//                             minWidth: isMobile ? '200px' : '250px',
//                             maxWidth: isMobile ? '90%' : 'none',
//                             display: 'inline-flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             transition: 'all 0.3s ease',
//                             boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
//                             height: isMobile ? '45px' : '50px'
//                         }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.backgroundColor = '#388E3C';
//                             e.currentTarget.style.transform = 'translateY(-2px)';
//                             e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.backgroundColor = '#4CAF50';
//                             e.currentTarget.style.transform = 'translateY(0)';
//                             e.currentTarget.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)';
//                         }}
//                     >
//                         <FaChartBar aria-hidden="true" style={{ marginRight: '10px', fontSize: isMobile ? '16px' : '18px' }} />
//                         Generate Compliance Report
//                     </button>
//                 </div>
//             </div>

//             <div style={{ 
//                 padding: '15px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#7b1fa2',
//                     marginBottom: '20px',
//                     display: 'flex',
//                     alignItems: 'center'
//                 }}>
//                     <FaChartLine aria-hidden="true" style={{ marginRight: '10px' }} />
//                     Food Safety Performance Metrics
//                 </h4>
                
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                     gap: '15px'
//                 }}>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>0</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Critical Violations</div>
//                         <div style={{ fontSize: '12px', color: '#4CAF50', fontWeight: 'bold' }}>This Month</div>
//                     </div>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>3</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Minor Violations</div>
//                         <div style={{ fontSize: '12px', color: '#2196F3', fontWeight: 'bold' }}>Resolving</div>
//                     </div>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>12</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Completed Audits</div>
//                         <div style={{ fontSize: '12px', color: '#FF9800', fontWeight: 'bold' }}>Last 90 Days</div>
//                     </div>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>94%</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Compliance Score</div>
//                         <div style={{ fontSize: '12px', color: '#9C27B0', fontWeight: 'bold' }}>Industry Average: 89%</div>
//                     </div>
//                 </div>
//             </div>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 textAlign: 'center'
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#2e7d32',
//                     marginBottom: '15px'
//                 }}>
//                     🏆 Compliance Excellence Recognition
//                 </h4>
//                 <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#333', marginBottom: '20px' }}>
//                     Your establishment maintains <strong>94% compliance score</strong>, placing you in the <strong>top 15%</strong> 
//                     of Food & Beverage businesses on our platform. Keep up the excellent work!
//                 </p>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     gap: '20px',
//                     flexWrap: 'wrap'
//                 }}>
//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '8px',
//                         minWidth: isMobile ? '130px' : '150px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Current Streak</div>
//                         <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>180</div>
//                         <div style={{ fontSize: '12px', color: '#666' }}>Days without violations</div>
//                     </div>
//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '8px',
//                         minWidth: isMobile ? '130px' : '150px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Industry Rank</div>
//                         <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>Top 15%</div>
//                         <div style={{ fontSize: '12px', color: '#666' }}>Among 500+ restaurants</div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ComplianceStatus;














import React, { useState, useCallback, useEffect } from "react";
import { 
  FaChartBar, 
  FaChartPie, 
  FaCheckCircle, 
  FaClock, 
  FaExclamationCircle,
  FaClipboardCheck,
  FaCalendarCheck,
  FaRegCalendarAlt,
  FaChartLine,
  FaExclamationTriangle,
  FaUsers,
  FaStar,
  FaUserShield,
  FaDatabase,
  FaServer,
  FaShieldAlt,
  FaNetworkWired,
  FaLock,
  FaGavel,
  FaEye
} from "react-icons/fa";

const ComplianceStatus = ({ isMobile }) => {
    const [complianceData, setComplianceData] = useState({
        platformSecurity: { status: "compliant", lastUpdated: "2024-03-15" },
        dataGovernance: { status: "compliant", lastUpdated: "2024-03-10" },
        regulatoryCompliance: { status: "pending", lastUpdated: "2024-02-28" },
        incidentResponse: { status: "compliant", lastUpdated: "2024-03-05" },
        auditTrails: { status: "non-compliant", lastUpdated: "2024-01-20" },
        vendorManagement: { status: "compliant", lastUpdated: "2024-03-12" }
    });

    const [adminId, setAdminId] = useState(null);

    const getStatusIcon = useCallback((status) => {
        switch(status) {
            case 'compliant': return <FaCheckCircle aria-hidden="true" style={{ color: '#4CAF50', marginRight: '5px' }} />;
            case 'pending': return <FaClock aria-hidden="true" style={{ color: '#FFC107', marginRight: '5px' }} />;
            case 'non-compliant': return <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '5px' }} />;
            default: return null;
        }
    }, []);

    const getStatusColor = useCallback((status) => {
        switch(status) {
            case 'compliant': return '#4CAF50';
            case 'pending': return '#FFC107';
            case 'non-compliant': return '#f44336';
            default: return '#757575';
        }
    }, []);

    useEffect(() => {
        const storedAdminId = localStorage.getItem("superAdminId") || "SA-" + Date.now();
        setAdminId(storedAdminId);
    }, []);

    return (
        <div style={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            padding: isMobile ? "15px" : "30px",
            border: "1px solid #e0e0e0",
            minHeight: "400px",
            overflow: "auto",
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)'
        }}>
            <div style={{ 
                textAlign: 'center', 
                marginBottom: '30px',
                paddingBottom: '20px',
                borderBottom: '2px solid #1a237e'
            }}>
                <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '15px',
                    backgroundColor: '#f5f7ff',
                    padding: '15px 30px',
                    borderRadius: '50px',
                    marginBottom: '15px'
                }}>
                    <FaUserShield style={{ 
                        fontSize: isMobile ? '28px' : '36px',
                        color: '#1a237e' 
                    }} />
                    <h3 style={{ 
                        fontSize: isMobile ? '20px' : '28px', 
                        color: '#1a237e',
                        margin: 0,
                        fontWeight: 'bold'
                    }}>
                        Platform Governance Dashboard
                    </h3>
                </div>
                <p style={{
                    color: '#666',
                    fontSize: isMobile ? '14px' : '16px',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    Real-time monitoring of platform security, compliance, and administrative governance
                </p>
            </div>

            {/* Overall Platform Health */}
            <div style={{ 
                padding: '25px', 
                borderRadius: '12px',
                marginBottom: '30px',
                backgroundColor: '#f5f7ff',
                border: '1px solid #d1d9ff'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '15px' : '0',
                    marginBottom: '25px'
                }}>
                    <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                        <h4 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#1a237e',
                            marginBottom: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <FaChartPie />
                            Platform Security & Compliance Score
                        </h4>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#666', maxWidth: '600px' }}>
                            Comprehensive assessment of security controls, regulatory compliance, and administrative governance
                        </p>
                    </div>
                    <div style={{
                        textAlign: 'center',
                        padding: '25px 30px',
                        border: "2px solid #1a237e",
                        borderRadius: '12px',
                        minWidth: isMobile ? '100%' : '220px',
                        backgroundColor: 'white'
                    }}>
                        <div style={{
                            fontSize: isMobile ? '36px' : '48px',
                            fontWeight: 'bold',
                            color: '#4CAF50',
                            marginBottom: '5px'
                        }}>
                            96%
                        </div>
                        <div style={{ 
                            fontSize: isMobile ? '14px' : '16px',
                            color: '#666',
                            fontWeight: 'bold'
                        }}>
                            Excellent Governance
                        </div>
                        <div style={{
                            fontSize: '12px',
                            color: '#4CAF50',
                            marginTop: '5px',
                            fontWeight: 'bold'
                        }}>
                            ▲ 3% from last quarter
                        </div>
                    </div>
                </div>
                
                <div style={{ marginTop: '20px' }}>
                    {[
                        { 
                            name: 'Platform Security', 
                            score: 98, 
                            color: '#4CAF50',
                            icon: <FaLock />,
                            description: 'Authentication, encryption, access controls'
                        },
                        { 
                            name: 'Data Governance', 
                            score: 95, 
                            color: '#2196F3',
                            icon: <FaDatabase />,
                            description: 'Privacy, retention, classification'
                        },
                        { 
                            name: 'Regulatory Compliance', 
                            score: 92, 
                            color: '#FF9800',
                            icon: <FaGavel />,
                            description: 'GDPR, PCI-DSS, industry standards'
                        },
                        { 
                            name: 'Incident Response', 
                            score: 90, 
                            color: '#9C27B0',
                            icon: <FaExclamationCircle />,
                            description: 'Detection, response, recovery'
                        },
                        { 
                            name: 'Audit & Monitoring', 
                            score: 88, 
                            color: '#607D8B',
                            icon: <FaEye />,
                            description: 'Logging, monitoring, reporting'
                        },
                        { 
                            name: 'Vendor Management', 
                            score: 94, 
                            color: '#00BCD4',
                            icon: <FaUsers />,
                            description: 'Third-party risk management'
                        }
                    ].map((category, index) => (
                        <div key={index} style={{ marginBottom: '15px' }}>
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                marginBottom: '5px',
                                alignItems: 'center'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ color: category.color, fontSize: '18px' }}>
                                        {category.icon}
                                    </span>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>
                                        {category.name}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: category.color }}>
                                        {category.score}%
                                    </span>
                                    <div style={{
                                        width: '40px',
                                        height: '10px',
                                        backgroundColor: '#e0e0e0',
                                        borderRadius: '5px',
                                        overflow: 'hidden'
                                    }}>
                                        <div style={{
                                            width: `${category.score}%`,
                                            height: '100%',
                                            backgroundColor: category.color,
                                            borderRadius: '5px'
                                        }}></div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ 
                                fontSize: '12px', 
                                color: '#666',
                                marginLeft: '28px',
                                marginTop: '2px'
                            }}>
                                {category.description}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Platform Governance Categories */}
            <div style={{ 
                marginBottom: '30px',
                padding: '25px',
                borderRadius: '12px',
                border: '1px solid #e0e0e0'
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '22px',
                    color: '#1a237e',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px'
                }}>
                    <FaServer />
                    Platform Governance Categories
                </h4>
                
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                    gap: '20px'
                }}>
                    {[
                        { 
                            id: 'security', 
                            name: 'Security Controls', 
                            description: 'Authentication, encryption, network security',
                            icon: <FaLock />, 
                            color: '#1a237e',
                            score: '98%',
                            metrics: ['MFA: 100%', 'Encryption: 98%', 'Access: 96%']
                        },
                        { 
                            id: 'compliance', 
                            name: 'Regulatory Compliance', 
                            description: 'GDPR, PCI-DSS, DPDP Act standards',
                            icon: <FaGavel />, 
                            color: '#283593',
                            score: '92%',
                            metrics: ['GDPR: 95%', 'PCI-DSS: 90%', 'DPDP: 91%']
                        },
                        { 
                            id: 'governance', 
                            name: 'Data Governance', 
                            description: 'Privacy, classification, lifecycle management',
                            icon: <FaDatabase />, 
                            color: '#303f9f',
                            score: '95%',
                            metrics: ['Retention: 97%', 'Classification: 94%', 'Privacy: 94%']
                        },
                        { 
                            id: 'monitoring', 
                            name: 'Security Monitoring', 
                            description: 'SIEM, SOC, threat detection systems',
                            icon: <FaEye />, 
                            color: '#5c6bc0',
                            score: '88%',
                            metrics: ['SOC Coverage: 100%', 'SIEM: 85%', 'Detection: 79%']
                        },
                        { 
                            id: 'incident', 
                            name: 'Incident Response', 
                            description: 'Detection, containment, recovery protocols',
                            icon: <FaExclamationCircle />, 
                            color: '#7986cb',
                            score: '90%',
                            metrics: ['Detection: 92%', 'Response: 88%', 'Recovery: 90%']
                        },
                        { 
                            id: 'audit', 
                            name: 'Audit & Reporting', 
                            description: 'Logging, compliance reports, documentation',
                            icon: <FaClipboardCheck />, 
                            color: '#9fa8da',
                            score: '87%',
                            metrics: ['Logging: 95%', 'Reports: 85%', 'Documentation: 81%']
                        }
                    ].map(category => (
                        <div 
                            key={category.id}
                            style={{
                                padding: '25px',
                                borderRadius: '10px',
                                border: `2px solid ${category.color}`,
                                backgroundColor: '#f8f9fa',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                position: 'relative'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                            onClick={() => alert(`View ${category.name} dashboard`)}
                        >
                            <div style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '15px'
                            }}>
                                <div style={{ 
                                    fontSize: '28px', 
                                    color: category.color
                                }}>
                                    {category.icon}
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    backgroundColor: category.color,
                                    padding: '4px 12px',
                                    borderRadius: '20px'
                                }}>
                                    {category.score}
                                </div>
                            </div>
                            
                            <div style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                fontWeight: 'bold',
                                color: '#333',
                                marginBottom: '10px',
                                lineHeight: '1.3'
                            }}>
                                {category.name}
                            </div>
                            
                            <div style={{ 
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#666',
                                marginBottom: '20px',
                                lineHeight: '1.5'
                            }}>
                                {category.description}
                            </div>
                            
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px'
                            }}>
                                {category.metrics.map((metric, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        fontSize: '12px',
                                        color: '#555'
                                    }}>
                                        <span>{metric.split(':')[0]}:</span>
                                        <span style={{ 
                                            fontWeight: 'bold',
                                            color: category.color
                                        }}>
                                            {metric.split(':')[1]}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Critical Compliance Metrics */}
            <div style={{ 
                display: 'grid', 
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', 
                gap: '20px', 
                marginBottom: '30px' 
            }}>
                {[
                    { 
                        title: "Security Patch Compliance", 
                        status: "compliant", 
                        score: "99.8%",
                        icon: <FaCheckCircle />,
                        color: "#4CAF50",
                        lastCheck: "2 hours ago",
                        details: "Critical patches applied within 24 hours",
                        trend: "▲ 0.5%",
                        metric: "Time to patch: 18h avg"
                    },
                    { 
                        title: "Authentication Security", 
                        status: "compliant", 
                        score: "98.5%",
                        icon: <FaLock />,
                        color: "#4CAF50",
                        lastCheck: "Today",
                        details: "MFA coverage, password policies",
                        trend: "▲ 2%",
                        metric: "MFA adoption: 100%"
                    },
                    { 
                        title: "Data Encryption", 
                        status: "compliant", 
                        score: "97.2%",
                        icon: <FaDatabase />,
                        color: "#4CAF50",
                        lastCheck: "Yesterday",
                        details: "Encryption at rest and in transit",
                        trend: "▲ 1.3%",
                        metric: "AES-256 coverage: 95%"
                    },
                    { 
                        title: "Audit Trail Integrity", 
                        status: "non-compliant", 
                        score: "82%",
                        icon: <FaExclamationTriangle />,
                        color: "#f44336",
                        lastCheck: "1 week ago",
                        details: "Log completeness and retention",
                        trend: "▼ 8%",
                        metric: "Missing logs: 18%"
                    },
                    { 
                        title: "GDPR Compliance", 
                        status: "pending", 
                        score: "88%",
                        icon: <FaClock />,
                        color: "#FFC107",
                        lastCheck: "3 days ago",
                        details: "Data subject rights, consent management",
                        trend: "▼ 2%",
                        metric: "SAR response: 72h avg"
                    },
                    { 
                        title: "Incident Response Time", 
                        status: "compliant", 
                        score: "91%",
                        icon: <FaExclamationCircle />,
                        color: "#4CAF50",
                        lastCheck: "Today",
                        details: "Detection to containment time",
                        trend: "▲ 4%",
                        metric: "Mean time: 42min"
                    }
                ].map((item, index) => (
                    <div 
                        key={index} 
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: "25px",
                            border: "1px solid #e0e0e0",
                            borderLeft: `5px solid ${item.color}`,
                            transition: 'all 0.3s ease',
                            cursor: 'pointer',
                            position: 'relative',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
                        }}
                        onClick={() => alert(`View detailed metrics for ${item.title}`)}
                    >
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'flex-start',
                            marginBottom: '20px'
                        }}>
                            <div style={{ flex: 1 }}>
                                <h5 style={{ 
                                    margin: '0 0 10px 0', 
                                    color: '#333',
                                    fontSize: isMobile ? '16px' : '18px',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    {item.icon}
                                    {item.title}
                                </h5>
                                
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    marginBottom: '10px',
                                    gap: '15px'
                                }}>
                                    <span style={{ 
                                        color: item.color,
                                        fontWeight: 'bold',
                                        fontSize: isMobile ? '24px' : '28px',
                                        minWidth: '70px'
                                    }}>
                                        {item.score}
                                    </span>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                        <span style={{ 
                                            color: item.color,
                                            padding: '4px 12px',
                                            borderRadius: '15px',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            backgroundColor: `${item.color}15`,
                                            alignSelf: 'flex-start'
                                        }}>
                                            {item.status}
                                        </span>
                                        <span style={{ 
                                            color: item.trend.startsWith('▲') ? '#4CAF50' : 
                                                   item.trend.startsWith('▼') ? '#f44336' : '#666',
                                            fontSize: '12px',
                                            fontWeight: 'bold'
                                        }}>
                                            {item.trend} this month
                                        </span>
                                    </div>
                                </div>
                                
                                <div style={{ 
                                    fontSize: '13px',
                                    color: '#666',
                                    marginTop: '12px',
                                    lineHeight: '1.5'
                                }}>
                                    {item.details}
                                </div>
                                
                                <div style={{ 
                                    fontSize: '12px',
                                    color: '#888',
                                    marginTop: '10px',
                                    padding: '8px 12px',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '6px',
                                    fontWeight: 'bold'
                                }}>
                                    {item.metric}
                                </div>
                            </div>
                        </div>
                        
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            fontSize: '12px',
                            color: '#666',
                            marginTop: '20px',
                            paddingTop: '15px',
                            borderTop: '1px solid #f0f0f0'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <FaRegCalendarAlt style={{ fontSize: '12px' }} />
                                Last check: {item.lastCheck}
                            </div>
                            <div style={{
                                padding: '4px 10px',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 'bold'
                            }}>
                                Admin: SA-{adminId?.slice(-6) || 'SYSTEM'}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Compliance Audits & Assessments */}
            <div style={{ 
                padding: '30px', 
                borderRadius: '12px',
                marginBottom: '30px',
                backgroundColor: '#e8f5e9',
                border: '1px solid #c8e6c9'
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '22px',
                    color: '#2e7d32',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px'
                }}>
                    <FaCalendarCheck />
                    Upcoming Security & Compliance Audits
                </h4>
                
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                    gap: '20px'
                }}>
                    {[
                        { 
                            title: "PCI-DSS Level 1 Audit", 
                            date: "2024-04-20", 
                            status: "scheduled",
                            type: "External",
                            priority: "critical",
                            auditor: "Qualified Security Assessor",
                            scope: "Payment processing systems",
                            requirements: ["SAQ D", "RoC", "ASV Scan"]
                        },
                        { 
                            title: "ISO 27001:2022 Recertification", 
                            date: "2024-05-15", 
                            status: "pending",
                            type: "External",
                            priority: "high",
                            auditor: "Certification Body",
                            scope: "Information security management",
                            requirements: ["ISMS Review", "Risk Assessment", "Documentation"]
                        },
                        { 
                            title: "GDPR Compliance Audit", 
                            date: "2024-06-01", 
                            status: "planned",
                            type: "Internal",
                            priority: "high",
                            auditor: "Data Protection Officer",
                            scope: "Data processing activities",
                            requirements: ["DPIA", "Records of Processing", "Consent Records"]
                        },
                        { 
                            title: "Penetration Test", 
                            date: "2024-04-30", 
                            status: "scheduled",
                            type: "External",
                            priority: "critical",
                            auditor: "Security Testing Firm",
                            scope: "Production environment",
                            requirements: ["Network Testing", "Web App Testing", "Social Engineering"]
                        }
                    ].map((audit, index) => (
                        <div 
                            key={index}
                            style={{
                                padding: '25px',
                                borderRadius: '10px',
                                border: '1px solid #e0e0e0',
                                backgroundColor: 'white'
                            }}
                        >
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '15px',
                                flexDirection: isMobile ? 'column' : 'row',
                                gap: isMobile ? '12px' : '0'
                            }}>
                                <div style={{ flex: 1 }}>
                                    <h6 style={{ 
                                        margin: 0,
                                        fontSize: isMobile ? '16px' : '18px',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        lineHeight: '1.3',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <div style={{
                                            padding: '4px 10px',
                                            backgroundColor: audit.priority === 'critical' ? '#ffebee' : 
                                                           audit.priority === 'high' ? '#fff3e0' : '#e8f5e9',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            color: audit.priority === 'critical' ? '#d32f2f' : 
                                                   audit.priority === 'high' ? '#f57c00' : '#388e3c'
                                        }}>
                                            {audit.type}
                                        </div>
                                        {audit.title}
                                    </h6>
                                    <div style={{ 
                                        fontSize: isMobile ? '12px' : '13px',
                                        color: '#666',
                                        marginTop: '12px',
                                        lineHeight: '1.5'
                                    }}>
                                        <div><strong>Auditor:</strong> {audit.auditor}</div>
                                        <div><strong>Scope:</strong> {audit.scope}</div>
                                    </div>
                                </div>
                                <span style={{ 
                                    color: audit.status === 'scheduled' ? '#2e7d32' : 
                                           audit.status === 'pending' ? '#FF9800' : '#2196F3',
                                    padding: '6px 14px',
                                    borderRadius: '15px',
                                    fontSize: isMobile ? '11px' : '13px',
                                    fontWeight: 'bold',
                                    whiteSpace: 'nowrap',
                                    alignSelf: isMobile ? 'flex-start' : 'center',
                                    backgroundColor: `${audit.status === 'scheduled' ? '#4CAF50' : 
                                                    audit.status === 'pending' ? '#FF9800' : '#2196F3'}15`
                                }}>
                                    {audit.status.toUpperCase()}
                                </span>
                            </div>
                            
                            <div style={{ 
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#666',
                                marginTop: '20px'
                            }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>
                                    Key Requirements:
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '8px'
                                }}>
                                    {audit.requirements.map((req, idx) => (
                                        <span key={idx} style={{
                                            padding: '4px 10px',
                                            backgroundColor: '#f5f5f5',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            color: '#555'
                                        }}>
                                            {req}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#666',
                                marginTop: '20px',
                                paddingTop: '15px',
                                borderTop: '1px solid #f0f0f0'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <FaRegCalendarAlt style={{ fontSize: '14px' }} />
                                    <strong>Audit Date:</strong> {audit.date}
                                </div>
                                <div style={{ 
                                    color: audit.priority === 'critical' ? '#d32f2f' : 
                                           audit.priority === 'high' ? '#f57c00' : '#388e3c',
                                    padding: '4px 10px',
                                    borderRadius: '10px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    backgroundColor: `${audit.priority === 'critical' ? '#d32f2f' : 
                                                    audit.priority === 'high' ? '#f57c00' : '#388e3c'}15`
                                }}>
                                    {audit.priority.toUpperCase()} PRIORITY
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Security Incidents & Alerts */}
            <div style={{ 
                padding: '30px', 
                borderRadius: '12px',
                marginBottom: '30px',
                backgroundColor: '#fff3e0',
                border: '1px solid #ffe0b2'
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '22px',
                    color: '#e65100',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px'
                }}>
                    <FaExclamationTriangle />
                    Security Incidents & High Priority Actions
                </h4>
                
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                    gap: '20px',
                    marginBottom: '25px'
                }}>
                    <div style={{ 
                        padding: '25px', 
                        borderRadius: '10px', 
                        border: '2px solid #f44336',
                        backgroundColor: '#ffffff'
                    }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}>
                            <FaExclamationTriangle style={{ color: '#f44336', marginRight: '12px', fontSize: '24px' }} />
                            <strong style={{ color: '#f44336', fontSize: isMobile ? '16px' : '18px' }}>
                                Critical Security Actions (Within 24 hours)
                            </strong>
                        </div>
                        <ul style={{ 
                            paddingLeft: '20px', 
                            fontSize: '14px', 
                            margin: 0,
                            color: '#555'
                        }}>
                            <li style={{ marginBottom: '12px', paddingLeft: '10px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                <FaExclamationCircle style={{ color: '#f44336', flexShrink: 0, marginTop: '2px' }} />
                                <div>
                                    <strong>Log Retention Gap:</strong> 18% of audit logs incomplete for March 15-20
                                    <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                        Required: 100% coverage, Actual: 82%
                                    </div>
                                </div>
                            </li>
                            <li style={{ marginBottom: '12px', paddingLeft: '10px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                <FaExclamationCircle style={{ color: '#f44336', flexShrink: 0, marginTop: '2px' }} />
                                <div>
                                    <strong>PCI-DSS Control Gap:</strong> ASV scan overdue by 3 days
                                    <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                        Required: Quarterly scans, Last: Jan 15
                                    </div>
                                </div>
                            </li>
                            <li style={{ paddingLeft: '10px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                <FaExclamationCircle style={{ color: '#f44336', flexShrink: 0, marginTop: '2px' }} />
                                <div>
                                    <strong>Encryption Standard:</strong> 5% of data stores not using AES-256
                                    <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                        Required: 100% AES-256, Actual: 95%
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    
                    <div style={{ 
                        padding: '25px', 
                        borderRadius: '10px', 
                        border: '2px solid #FF9800',
                        backgroundColor: '#ffffff'
                    }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}>
                            <FaClock style={{ color: '#FF9800', marginRight: '12px', fontSize: '24px' }} />
                            <strong style={{ color: '#FF9800', fontSize: isMobile ? '16px' : '18px' }}>
                                Upcoming Compliance Deadlines
                            </strong>
                        </div>
                        <ul style={{ 
                            paddingLeft: '20px', 
                            fontSize: '14px', 
                            margin: 0,
                            color: '#555'
                        }}>
                            <li style={{ marginBottom: '12px', paddingLeft: '10px' }}>
                                <strong>Q1 Security Report:</strong> Due to Board on April 30, 2024
                                <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                    Status: 70% complete
                                </div>
                            </li>
                            <li style={{ marginBottom: '12px', paddingLeft: '10px' }}>
                                <strong>GDPR Data Mapping:</strong> Annual update due May 15, 2024
                                <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                    Last completed: May 20, 2023
                                </div>
                            </li>
                            <li style={{ marginBottom: '12px', paddingLeft: '10px' }}>
                                <strong>Security Awareness Training:</strong> Bi-annual due June 1, 2024
                                <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                    Completion rate: 85% (target: 100%)
                                </div>
                            </li>
                            <li style={{ paddingLeft: '10px' }}>
                                <strong>Third-party Risk Assessment:</strong> Annual review due June 15, 2024
                                <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                    Vendors to assess: 127
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                    <button 
                        onClick={() => alert("Generate Security Compliance Report")}
                        style={{
                            backgroundColor: '#1a237e',
                            color: 'white',
                            border: 'none',
                            padding: isMobile ? '12px 25px' : '15px 40px',
                            borderRadius: '50px',
                            cursor: 'pointer',
                            fontSize: isMobile ? '14px' : '16px',
                            fontWeight: 'bold',
                            minWidth: isMobile ? '200px' : '250px',
                            maxWidth: isMobile ? '90%' : 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '12px',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 15px rgba(26, 35, 126, 0.3)',
                            height: isMobile ? '45px' : '50px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#283593';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(26, 35, 126, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#1a237e';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(26, 35, 126, 0.3)';
                        }}
                    >
                        <FaChartBar style={{ fontSize: isMobile ? '16px' : '18px' }} />
                        Generate Security Compliance Report
                    </button>
                </div>
            </div>

            {/* Key Performance Indicators */}
            <div style={{ 
                padding: '30px', 
                borderRadius: '12px',
                marginBottom: '30px',
                backgroundColor: '#e3f2fd',
                border: '1px solid #bbdefb'
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '22px',
                    color: '#1565c0',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px'
                }}>
                    <FaChartLine />
                    Security & Compliance KPIs
                </h4>
                
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    gap: '20px'
                }}>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '25px', 
                        borderRadius: '10px',
                        border: '1px solid #bbdefb',
                        backgroundColor: 'white'
                    }}>
                        <div style={{ 
                            fontSize: isMobile ? '28px' : '32px', 
                            color: '#4CAF50', 
                            fontWeight: 'bold', 
                            marginBottom: '10px' 
                        }}>
                            0
                        </div>
                        <div style={{ 
                            fontSize: isMobile ? '12px' : '14px', 
                            color: '#666', 
                            marginBottom: '5px',
                            fontWeight: 'bold'
                        }}>
                            Security Incidents
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#4CAF50', 
                            fontWeight: 'bold' 
                        }}>
                            Last 30 days
                        </div>
                    </div>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '25px', 
                        borderRadius: '10px',
                        border: '1px solid #bbdefb',
                        backgroundColor: 'white'
                    }}>
                        <div style={{ 
                            fontSize: isMobile ? '28px' : '32px', 
                            color: '#2196F3', 
                            fontWeight: 'bold', 
                            marginBottom: '10px' 
                        }}>
                            99.95%
                        </div>
                        <div style={{ 
                            fontSize: isMobile ? '12px' : '14px', 
                            color: '#666', 
                            marginBottom: '5px',
                            fontWeight: 'bold'
                        }}>
                            System Uptime
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#2196F3', 
                            fontWeight: 'bold' 
                        }}>
                            SLA: 99.9%
                        </div>
                    </div>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '25px', 
                        borderRadius: '10px',
                        border: '1px solid #bbdefb',
                        backgroundColor: 'white'
                    }}>
                        <div style={{ 
                            fontSize: isMobile ? '28px' : '32px', 
                            color: '#FF9800', 
                            fontWeight: 'bold', 
                            marginBottom: '10px' 
                        }}>
                            42min
                        </div>
                        <div style={{ 
                            fontSize: isMobile ? '12px' : '14px', 
                            color: '#666', 
                            marginBottom: '5px',
                            fontWeight: 'bold'
                        }}>
                            Mean Time to Detect
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#FF9800', 
                            fontWeight: 'bold' 
                        }}>
                            Target: ≤30min
                        </div>
                    </div>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '25px', 
                        borderRadius: '10px',
                        border: '1px solid #bbdefb',
                        backgroundColor: 'white'
                    }}>
                        <div style={{ 
                            fontSize: isMobile ? '28px' : '32px', 
                            color: '#9C27B0', 
                            fontWeight: 'bold', 
                            marginBottom: '10px' 
                        }}>
                            96%
                        </div>
                        <div style={{ 
                            fontSize: isMobile ? '12px' : '14px', 
                            color: '#666', 
                            marginBottom: '5px',
                            fontWeight: 'bold'
                        }}>
                            Overall Compliance
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#9C27B0', 
                            fontWeight: 'bold' 
                        }}>
                            Industry Average: 89%
                        </div>
                    </div>
                </div>
            </div>

            {/* Governance Excellence Recognition */}
            <div style={{ 
                padding: '30px', 
                borderRadius: '12px',
                textAlign: 'center',
                backgroundColor: '#1a237e',
                color: 'white'
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '22px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '15px'
                }}>
                    <FaUserShield />
                    Platform Governance Excellence
                </h4>
                <p style={{ 
                    fontSize: isMobile ? '14px' : '16px', 
                    marginBottom: '25px',
                    opacity: 0.9,
                    maxWidth: '800px',
                    margin: '0 auto 25px auto'
                }}>
                    Your platform maintains a <strong>96% compliance score</strong>, placing you in the <strong>top 10%</strong> 
                    of enterprise platforms. Security controls exceed industry standards by 7%.
                </p>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '25px',
                    flexWrap: 'wrap'
                }}>
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        minWidth: isMobile ? '140px' : '160px',
                        border: '1px solid rgba(255,255,255,0.2)',
                        backgroundColor: 'rgba(255,255,255,0.1)'
                    }}>
                        <div style={{ 
                            fontSize: '11px', 
                            marginBottom: '8px',
                            opacity: 0.8 
                        }}>
                            Compliance Streak
                        </div>
                        <div style={{ 
                            fontSize: '28px', 
                            color: '#4CAF50', 
                            fontWeight: 'bold',
                            marginBottom: '5px'
                        }}>
                            365
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            opacity: 0.7 
                        }}>
                            Days without security incidents
                        </div>
                    </div>
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        minWidth: isMobile ? '140px' : '160px',
                        border: '1px solid rgba(255,255,255,0.2)',
                        backgroundColor: 'rgba(255,255,255,0.1)'
                    }}>
                        <div style={{ 
                            fontSize: '11px', 
                            marginBottom: '8px',
                            opacity: 0.8 
                        }}>
                            Industry Ranking
                        </div>
                        <div style={{ 
                            fontSize: '28px', 
                            color: '#4CAF50', 
                            fontWeight: 'bold',
                            marginBottom: '5px'
                        }}>
                            Top 10%
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            opacity: 0.7 
                        }}>
                            Among 1000+ enterprise platforms
                        </div>
                    </div>
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        minWidth: isMobile ? '140px' : '160px',
                        border: '1px solid rgba(255,255,255,0.2)',
                        backgroundColor: 'rgba(255,255,255,0.1)'
                    }}>
                        <div style={{ 
                            fontSize: '11px', 
                            marginBottom: '8px',
                            opacity: 0.8 
                        }}>
                            Audit Success Rate
                        </div>
                        <div style={{ 
                            fontSize: '28px', 
                            color: '#4CAF50', 
                            fontWeight: 'bold',
                            marginBottom: '5px'
                        }}>
                            100%
                        </div>
                        <div style={{ 
                            fontSize: '12px', 
                            opacity: 0.7 
                        }}>
                            Last 5 external audits
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComplianceStatus;